<template>

    <div>

        <div v-if="isLeavingReply">

            <textarea class="form-textarea bg-theme-level4 text-theme-main w-full" name="body" rows="2" v-model="commentBody"></textarea><br />

            <div class="flex flex-row justify-end">

                <button type="button" class="mt-2 mr-2 hover:bg-theme-controls1 text-theme-main p-2 rounded" @click="postComment">
                    {{ button_label }}
                </button>

                <button type="button" class="mt-2 hover:bg-theme-controls1 text-theme-muted hover:text-theme-main p-2 rounded" @click="isLeavingReply=false">
                    {{ translate('cancel') }}
                </button>

            </div>

        </div>



        <p v-if="!isLeavingReply" class="text-sm text-theme-discrete hover:text-theme-main hover:underline cursor-pointer mb-4" @click="isLeavingReply=true">{{ button_label }}</p>

    </div>

</template>

<script>

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        props: [
            'language',
            'content_id',
            'parent_id',
            'button_label'
        ],

        data() {

            return {

                commentBody: '',
                isLeavingReply: false

            }

        },

        methods: {

            postComment() {


                let theParent = this.parent_id ? this.parent_id : null;

                 axios.post('/' + this.language + '/comment', {

                    'language': this.language,
                    'contentId': this.content_id,
                    'parentId': theParent,
                    'body': this.commentBody

                }).then((response) => {

                    console.log('Done saving comment.');
                    console.log('Updating data...')

                     axios.get('/api/comments/' + this.content_id)
                         .then((response) => {
                             this.$root.shared.full_comment_data = response.data
                             this.isLeavingReply = false;
                             this.$parent.repliesAreVisible = true;
                         })
                         .catch((error) => {
                             console.log('Error obtaining COMMENTS data: ' + error)
                         })

                }).catch((error) => {
                    console.log('Error saving comment: ' + error);
                })

            },

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

        }

    }

</script>

<style>

.form-enter-active, .form-leave-active {
    transition: all 0.35s;
}

.form-enter, .form-leave-to {
    opacity: 0;
}

</style>
